/* eslint no-param-reassign: 0 */
/* eslint no-unused-vars: 0 */
/* eslint camelcase: 0 */
/* eslint no-underscore-dangle: 0 */
import Vue from 'vue';
import VueLocalStorage from 'vue-localstorage';

Vue.use(VueLocalStorage);

const existsInLs = (attrName: string) => (typeof Vue.localStorage.get(attrName) !== 'undefined') && Vue.localStorage.get(attrName) !== 'undefined';

const mainState = {
  loggedInUser: existsInLs('loggedInUser') ? JSON.parse(Vue.localStorage.get('loggedInUser')) : null,
  userData: existsInLs('userData') ? JSON.parse(Vue.localStorage.get('userData')) : {},
  isAnon: existsInLs('isAnon') ? Vue.localStorage.get('isAnon') : null,
  presence: null,
};

const adj = ['admiring', 'adoring', 'affectionate', 'agitated', 'amazing', 'angry', 'awesome', 'beautiful', 'blissful', 'bold', 'boring', 'brave', 'busy', 'charming', 'clever', 'cool', 'compassionate', 'competent', 'condescending', 'confident', 'cranky', 'crazy', 'dazzling', 'determined', 'distracted', 'dreamy', 'eager', 'ecstatic', 'elastic', 'elated', 'elegant', 'eloquent', 'epic', 'exciting', 'fervent', 'festive', 'flamboyant', 'focused', 'friendly', 'frosty', 'funny', 'gallant', 'gifted', 'goofy', 'gracious', 'great', 'happy', 'hardcore', 'heuristic', 'hopeful', 'hungry', 'infallible', 'inspiring', 'interesting', 'intelligent', 'jolly', 'jovial', 'keen', 'kind', 'laughing', 'loving', 'lucid', 'magical', 'mystifying', 'modest', 'musing', 'naughty', 'nervous', 'nice', 'nifty', 'nostalgic', 'objective', 'optimistic', 'peaceful', 'pedantic', 'pensive', 'practical', 'priceless', 'quirky', 'quizzical', 'recursing', 'relaxed', 'reverent', 'romantic', 'sad', 'serene', 'sharp', 'silly', 'sleepy', 'stoic', 'strange', 'suspicious', 'sweet', 'tender', 'thirsty', 'trusting', 'unruffled', 'upbeat', 'vibrant', 'vigilant', 'vigorous', 'wizardly', 'wonderful', 'xenodochial', 'youthful', 'zealous', 'zen'];
const ply = ['Magnus', 'Carlsen', 'Garry', 'Kasparov', 'Bobby', 'Fischer', 'Anatoly', 'Karpov', 'Vishy', 'Anand', 'Tal', 'Capablanca', 'Alekhine', 'Botvinnik', 'Morphy', 'Caruana', 'Kramnik', 'Grischuk', 'Topalov', 'Nakamura', 'Lasker', 'Tarrasch', 'Nimzowitsch'];

const hashCode = (s) => {
  let h = 0;
  for (let i = 0; i < s.length; i += 1) {
    h = Math.imul(31, h) + s.charCodeAt(i) | 0;
  }
  return h;
};

const defUsername = (loggedInUser) => {
  const hash = hashCode(loggedInUser.uid);
  const theAdj = adj[((hash % adj.length) + adj.length) % adj.length];
  const thePly = ply[((hash % ply.length) + ply.length) % ply.length];
  const theCnt = ((hash % 1000) + 1000) % 1000;
  return `${theAdj}${thePly}${theCnt}`;
};

const getters = {
  isAnonymous(st) {
    return st.isAnon;
  },
  isLoggedIn(st) {
    return st.loggedInUser !== null;
  },
  getPresence(st) {
    return st.presence;
  },
  getCurrentUser(st) {
    return st.loggedInUser;
  },
  getDefaultUsername(st) {
    return defUsername(st.loggedInUser);
  },
  getUserData(st) {
    return st.userData;
  },
};

const mutations = {
  setUser(state, user) {
    if (user.isAnonymous) {
      state.isAnon = true;
    } else {
      state.isAnon = false;
    }
    state.loggedInUser = user;
    Vue.localStorage.set('loggedInUser', JSON.stringify(user));
    Vue.localStorage.set('isAnon', state.isAnon);
  },
  setUserData(state, userData) {
    state.userData = userData;
    Vue.localStorage.set('userData', JSON.stringify(userData));
  },
  setPresence(state, presence) {
    state.presence = presence;
  },
  logout(state) {
    state.loggedInUser = null;
    Vue.localStorage.remove('loggedInUser');
    Vue.localStorage.remove('userData');
    Vue.localStorage.remove('isAnon');
    window.firebase.auth().signOut();
    // .then(function() {
    //   // Sign-out successful.
    // }).catch(function(error) {
    //   // An error happened.
    // });
  },
};

const actions = {
  setPresence({ commit }, presence) {
    commit('setPresence', presence);
  },
  setUserData({ commit }, userData) {
    commit('setUserData', userData);
  },
  setUser({ commit }, user) {
    commit('setUser', user);
  },
  logout({ commit }) {
    commit('logout');
  },
};

export default {
  state: mainState,
  getters,
  mutations,
  actions,
};
